import { lazy, Suspense } from "react";
import PropTypes from "prop-types";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import GROUPS_CONSTANTS from "./Customers.constants";
import { CustomizedSwitch } from "styles/formStyleComponents";
import {
  EntitlementLabel,
  EntitlementRow,
  EntitlementsAccessCell,
  EntitlementsHeader,
  EntitlementsHeaderLabel,
  EntitlementsLoadingBox,
  EntitlementsRoot,
  EntitlementsScroll,
  entitlementsInfoButtonSx,
  entitlementsTooltipSlotProps,
} from "./CustomerDetailsDrawer.styles";

const PAGE_ACCESS_COLUMN_HEADERS =
  GROUPS_CONSTANTS.groupAccessDrawer.COLUMN_HEADERS;
const Loading = lazy(() => import("common/Components/Loading"));

const CustomerEntitlementsTab = ({
  loadingModules,
  moduleRows,
  switchesDisabled,
  onToggle,
}) => (
  <EntitlementsRoot>
    <EntitlementsHeader>
      <EntitlementsHeaderLabel>
        {PAGE_ACCESS_COLUMN_HEADERS.MODULE_NAME}
      </EntitlementsHeaderLabel>
      <EntitlementsAccessCell>
        <EntitlementsHeaderLabel component="span">
          {PAGE_ACCESS_COLUMN_HEADERS.ACCESS}
        </EntitlementsHeaderLabel>
        <Tooltip
          title={GROUPS_CONSTANTS.groupAccessDrawer.ACCESS_COLUMN_TOOLTIP}
          arrow
          placement="bottom"
          enterTouchDelay={0}
          leaveTouchDelay={4000}
          describeChild
          slotProps={entitlementsTooltipSlotProps}
        >
          <IconButton
            size="small"
            sx={entitlementsInfoButtonSx}
            aria-label={GROUPS_CONSTANTS.groupAccessDrawer.ACCESS_COLUMN_TOOLTIP}
          >
            <InfoOutlinedIcon sx={{ fontSize: 16 }} />
          </IconButton>
        </Tooltip>
      </EntitlementsAccessCell>
    </EntitlementsHeader>

    {loadingModules ? (
      <EntitlementsLoadingBox>
        <Suspense fallback={<div>{GROUPS_CONSTANTS.loading.FALLBACK}</div>}>
          <Loading />
        </Suspense>
      </EntitlementsLoadingBox>
    ) : (
      <EntitlementsScroll>
        {moduleRows.map((row) => (
          <EntitlementRow key={row.module}>
            <EntitlementLabel>{row.label}</EntitlementLabel>
            <CustomizedSwitch
              checked={Boolean(row.enabled)}
              disabled={switchesDisabled}
              onChange={(e) => onToggle(row.module, e.target.checked)}
              inputProps={{ "aria-label": `${row.label} access` }}
            />
          </EntitlementRow>
        ))}
      </EntitlementsScroll>
    )}
  </EntitlementsRoot>
);

CustomerEntitlementsTab.propTypes = {
  loadingModules: PropTypes.bool.isRequired,
  moduleRows: PropTypes.arrayOf(
    PropTypes.shape({
      module: PropTypes.string.isRequired,
      enabled: PropTypes.bool.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  switchesDisabled: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
};

export default CustomerEntitlementsTab;
